module.exports = __webpack_public_path__ + "assets/img/solution7.aea83bee.png";